import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { LocaleContext, ThemeProvider } from 'bold-ui'
import ptBr from 'bold-ui/lib/i18n/locales/pt-BR'
import { ChamadaPainelApp } from 'ChamadaPainelApp'
import { history } from 'config'
import theme from 'config/theme'
import { useLocalStorageState } from 'hooks/useStorage'
import { Route, Router, Switch } from 'react-router'
import { PainelChamadasErrorView } from 'view/chamada-painel/components/PainelChamadasErrorView'
import { PainelScaledLayout } from 'view/chamada-painel/components/PainelScaledLayout'
import { CHAMADA_PAINEL_ROUTES, CHAMADA_PAINEL_STORAGE_KEYS } from 'view/chamada-painel/constants-chamadaPainel'
import { CredenciaisChamadaPainel } from 'view/chamada-painel/model-chamadaPainel'

import { PecApp } from './PecApp'

const PecAppGuard = () => {
  const [credenciaisPainel] = useLocalStorageState<CredenciaisChamadaPainel | null>(
    CHAMADA_PAINEL_STORAGE_KEYS.CREDENCIAIS
  )

  if (credenciaisPainel) {
    return (
      <PainelScaledLayout>
        <PainelChamadasErrorView
          title='Dispositivo configurado para o painel de chamadas'
          description='Não é possível acessar o sistema como um usuário logado pois este navegador está autenticado como um painel de chamadas.'
        />
      </PainelScaledLayout>
    )
  }
  return <PecApp />
}

export const App = () => {
  return (
    <Router history={history}>
      <LocaleContext.Provider value={ptBr}>
        <EmotionThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <Switch>
              <Route path={CHAMADA_PAINEL_ROUTES.ROOT} component={ChamadaPainelApp} />
              <Route component={PecAppGuard} />
            </Switch>
          </ThemeProvider>
        </EmotionThemeProvider>
      </LocaleContext.Provider>
    </Router>
  )
}
